import request from "../utils/request";

export const list = (data) => request.get("/api/recommend", data);
export const select = (data) => request.get("/api/recommend/select", data);
export const create = (data) => request.post("/api/recommend", data);
export const update = (id, data) => request.put(`/api/recommend/${id}`, data);
export const remove = (id) => request.del(`/api/recommend/${id}`);
export const get = (id) => request.get(`/api/recommend/${id}`);